import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    CardActions,
    FunctionField
} from 'react-admin';
import {CardContent} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";


const rowStyle = (record) => ({
    backgroundColor: record.status === 'APPROVED' ? '#bbffbb' :
        (record.status === 'REJECTED' ? '#ffbbbb' : 'white')
});

const EmployeeRequestActions = ({
                             bulkActions,
                             basePath,
                             currentSort,
                             displayedFilters,
                             exporter,
                             filters,
                             filterValues,
                             onUnselectItems,
                             resource,
                             selectedIds,
                             showFilter,
                             total
                         }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
    </CardActions>
);

const translateForStatus = {
    APPROVED: "Прийняте",
    REJECTED: "Відхилено",
    NEW: "Чекає підтвердження",
    EXPIRED: 'Прострочено'
}

const Empty = () => {
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Запрошення співробітників - відсутні
            </Typography>
        </Box>
    );
};

export const EmployeeRequestList = (props) => (
    <List {...props}
          bulkActionButtons={false}
          perPage={25}
          title="Запрошення співробітників"
          actions={<EmployeeRequestActions />}
          className="list-styles"
          empty={<Empty />}
    >
        <Datagrid rowStyle={rowStyle}>
            <TextField sortable={false} label="Прізвище" source="lastName" />
            <TextField sortable={false} label="Iм'я" source="firstName" />
            <TextField sortable={false} label="По батькові" source="secondName" />
            <DateField sortable={false} label="Запрошення зроблено" source="insertedAt" locales="ru-RU" />
            <TextField sortable={false} label="Ідентифікаційний код" source="edrpou" />
            <FunctionField
                label="Статус" source="status"
                render={record => `${translateForStatus[record.status]}`}
            />
        </Datagrid>
    </List>
);

export default EmployeeRequestList;
